export default __webpack_public_path__ + "static/media/GreenCheckIcon.b922be0f.svg";